export default () => {
  document.querySelectorAll('[data-store-hours]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    el.setAttribute('initialized', 'true');

    const hide = () => {
      el.hidden = true;
      const heading = el.previousElementSibling;
      if (heading && heading.tagName === 'H4') {
        heading.hidden = true;
      }
    };

    const dataStr = el.getAttribute('data-store-hours');
    let data;
    try {
      data = JSON.parse(decodeURIComponent(dataStr.replace(/\+/g, ' ')));
    } catch (e) {
      hide();
      return;
    }

    if (!Array.isArray(data) || !data.length) {
      hide();
      return;
    }

    data.forEach((item) => {
      const str = `
        <div class="StoreDetail__hours-item">
          <b>${item.day}</b> ${item.hours}
        </div>
      `;
      el.insertAdjacentHTML('beforeend', str);
    });
  });
};
